const ActionToolType = {
  filter: "filter",
  data: "data",
  geozones: "geozones",
  documents: "documents",
  trackers: "trackers",
} as const;

export type ActionToolTypeValue =
  (typeof ActionToolType)[keyof typeof ActionToolType];

export default ActionToolType;
